import { render } from "./CustomAppError.vue?vue&type=template&id=47064d72"
import script from "./CustomAppError.vue?vue&type=script&lang=js"
export * from "./CustomAppError.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomAppError.vue"]])

export default __exports__